module.exports = __webpack_public_path__ + "img/banner63.a059750d.png";